import { Entity } from '@debbie/common/dist/index.js';
import * as search from '@debbie/cortex/dist/api/search.js';
import moment from 'moment';
import React from 'react';
import CaseStatus from '../components/CaseStatus.js';
import Layout from '../components/Icons/Layout.js';
import Users from '../components/Icons/Users.js';
import Zap from '../components/Icons/Zap.js';
import THEME from '../theme.js';
export const searchAll = async (lang, role, ...searchArgs) => {
    const q = searchArgs[0];
    if ((q && q.length <= 2) || !q) {
        return [];
    }
    const re = await search.all(...searchArgs);
    return re
        .filter((r) => {
        if (['caseworker', 'client'].includes(role)) {
            return r.item.entity === Entity.Case;
        }
        else {
            return true;
        }
    })
        .map((r) => {
        const { item, highlight } = r;
        switch (item.entity) {
            case Entity.Case:
                let subheader = (highlight.creditorName && highlight.creditorName[0]) ||
                    item.creditorName;
                if (highlight.userPhones && highlight.userPhones[0]) {
                    subheader = `${lang.search.phone}: ${highlight.userPhones[0]}`;
                }
                else if (highlight.userEmails && highlight.userEmails[0]) {
                    subheader = highlight.userEmails.join('');
                }
                else if (highlight.caseVoucherReferenceIds &&
                    highlight.caseVoucherReferenceIds[0]) {
                    subheader = `${lang.search.voucherReferenceId}: ${highlight.caseVoucherReferenceIds.join('')}`;
                }
                else if (highlight.userAddresses && highlight.userAddresses[0]) {
                    subheader = highlight.userAddresses[0];
                }
                else if (highlight.userCprs && highlight.userCprs[0]) {
                    subheader = `${lang.search.cpr}: ${highlight.userCprs.join('')}`;
                }
                else if (highlight.userCvrs && highlight.userCvrs[0]) {
                    subheader = `${lang.search.cvr}: ${highlight.userCvrs.join('')}`;
                }
                else if (highlight.tribunalCaseReferenceIds &&
                    highlight.tribunalCaseReferenceIds[0]) {
                    subheader = highlight.tribunalCaseReferenceIds.join('');
                }
                else if (highlight['properties.data'] &&
                    highlight['properties.data'][0]) {
                    subheader = `${lang.properties.properties}: ${highlight['properties.data'][0]}`;
                }
                return {
                    key: item.id,
                    heading: (React.createElement("div", { style: { display: 'inline-block' } },
                        React.createElement("span", { dangerouslySetInnerHTML: {
                                __html: (highlight.userNames && highlight.userNames[0]) ||
                                    item.userNames ||
                                    '',
                            } }),
                        ' ',
                        React.createElement(CaseStatus, { status: item.caseStatus }))),
                    small: (React.createElement("div", { dangerouslySetInnerHTML: {
                            __html: `${highlight.customerReferenceId &&
                                highlight.customerReferenceId[0]
                                ? highlight.customerReferenceId[0]
                                : ''} ${highlight.caseMigratedId && highlight.caseMigratedId[0]
                                ? `[${lang.search.migratedId}: ${highlight.caseMigratedId[0]}] `
                                : ''} ${(highlight.caseCustomJournalNumber &&
                                highlight.caseCustomJournalNumber[0]) ||
                                item.caseCustomJournalNumber ||
                                (highlight.caseSequentialId &&
                                    highlight.caseSequentialId[0]) ||
                                item.caseSequentialId}`,
                        } })),
                    supplementary: subheader
                        ? [
                            {
                                header: (React.createElement("span", { style: { float: 'left' }, dangerouslySetInnerHTML: {
                                        __html: subheader,
                                    } })),
                                small: moment(item.caseCreatedAt).format(THEME.DATE_FORMAT),
                            },
                        ]
                        : [],
                    returnData: { ...item, path: `/cases/${item.caseSequentialId}` },
                };
            case Entity.Creditor:
                return {
                    key: item.id,
                    heading: (React.createElement("div", { style: { display: 'inline-block' }, dangerouslySetInnerHTML: {
                            __html: (highlight.name && highlight.name[0]) || item.name || '',
                        } })),
                    small: (React.createElement(React.Fragment, null,
                        React.createElement(Users, { style: { margin: '0.15em 0 -0.15em' } }),
                        ' ',
                        lang.entities[Entity.Creditor])),
                    supplementary: [
                        {
                            header: (React.createElement("div", { dangerouslySetInnerHTML: {
                                    __html: (highlight.referenceId && highlight.referenceId[0]) ||
                                        item.referenceId ||
                                        '',
                                } })),
                        },
                    ],
                    returnData: { ...item, path: `/creditors/${item.id}` },
                };
            case Entity.Workflow:
                return {
                    key: item.id,
                    heading: (React.createElement("div", { style: { display: 'inline-block' }, dangerouslySetInnerHTML: {
                            __html: (highlight.workflowTitle && highlight.workflowTitle[0]) ||
                                item.workflowTitle ||
                                '',
                        } })),
                    small: (React.createElement(React.Fragment, null,
                        React.createElement(Zap, { style: { margin: '0.15em 0 -0.15em' } }),
                        ' ',
                        lang.entities[Entity.Workflow])),
                    returnData: { ...item, path: `/workflows/${item.id}` },
                };
            case Entity.Template:
                return {
                    key: item.id,
                    heading: (React.createElement("div", { style: { display: 'inline-block' }, dangerouslySetInnerHTML: {
                            __html: (highlight.templateName && highlight.templateName[0]) ||
                                item.templateName ||
                                '',
                        } })),
                    small: (React.createElement("div", null,
                        React.createElement(Layout, { style: { margin: '0.15em 0 -0.15em' } }),
                        ' ',
                        lang.entities[Entity.Template])),
                    returnData: {
                        ...item,
                        path: `/settings/template-editor/${item.id}`,
                    },
                };
            default:
                throw 'Search entity type not handled';
        }
    });
};
//# sourceMappingURL=index.js.map